import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const EXTERIOR = ["Front of bus","Engine compartment","Lights and reflectors","Tires","Wheels","Lug nuts","Suspension","Brakes","Steering components","Frame","Fuel tank","Exhaust system","Side panels","Windows","Mirrors","Stop arm","Crossing gate","Student loading lights","Rear of bus","Emergency exits"];
const INTERIOR = ["Driver seat","Seat belt","Steering wheel","Horn","Mirrors","Windshield","Windshield wipers","Gauges","Warning lights","Heater","Defroster","Service door","Emergency exits","Passenger seats","Aisle","Fire extinguisher","First aid kit","Body fluid cleanup kit","Reflective triangles","Child check system"];
const BRAKES = ["Parking brake test","Service brake test","Air brake check","Hydraulic brake check","Warning light check","Warning buzzer check","Brake pressure check","Brake pedal check","Safe brake operation procedures"];
const WHY = ["Build inspection confidence","Learn proper inspection order","Identify defects","Understand safety risks","Prepare for testing","Prepare for real-world operation","Develop consistent safety habits"];

export default function PreTripInspection() {
  return (
    <>
      <PageHero
        testid="pretrip-hero"
        eyebrow="Pre-Trip Inspection"
        title="Protecting students before the bus ever leaves the yard."
        description="A driver must know how to inspect the bus, explain the inspection clearly, identify defects, and understand why each item matters. Pre-trip training is about more than passing a test."
        image={IMAGES.preTrip}
      />

      <Section testid="pretrip-exterior">
        <SectionTitle eyebrow="Section A" title="Exterior Inspection Areas" description="The full walkaround — from front bumper to rear emergency exit." />
        <BulletGrid items={EXTERIOR} testid="pretrip-exterior-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="pretrip-interior">
        <SectionTitle eyebrow="Section B" title="Interior Inspection Areas" description="Inside the bus — driver controls, passenger area, and emergency equipment." />
        <BulletGrid items={INTERIOR} testid="pretrip-interior-grid" />
      </Section>

      <Section testid="pretrip-brakes">
        <SectionTitle eyebrow="Section C" title="Brake Check Training" description="Air, hydraulic, and parking brake procedures." />
        <BulletGrid items={BRAKES} testid="pretrip-brakes-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="pretrip-why">
        <SectionTitle eyebrow="Why It Matters" title="Strong pre-trip training builds career-long safety habits." />
        <BulletGrid items={WHY} testid="pretrip-why-grid" />
      </Section>

      <CTABand title="Master the pre-trip inspection." description="Contact CLB Solution to learn about pre-trip mastery training and the upcoming Pretrip Guide app." />
    </>
  );
}
